import React from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import FileToUpload from "../../components/FileToUpload";
import closeIcon from "../../images/icon-trash.svg";

class ServiceRequestsSubmit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fileToUpload: null,
      uploadProgress: 0,
      isLoading: false,
    };

    this.handleDeleteFileToUpload = this.handleDeleteFileToUpload.bind(this);
  }

  handleSelectFile(file) {
    if (file != null)
      this.parseInBase64(file).then((base64) => {
        this.setState({
          fileToUpload: {
            FileName: file.name,
            ContentType: file.type,
            Content: base64,
            Partition: this.props.clientId,
          },
          isLoading: false,
          uploadProgress: 0,
        });
      });
  }

  parseInBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  uploadFile() {
    this.setState({ isLoading: true });

    axios
      .post(
        `${BACKEND_CONFIG.apiUrl}/documents/${this.props.clientId}/files`,
        this.state.fileToUpload,
        {
          onUploadProgress: (ProgressEvent) => {
            this.setState({
              uploadProgress:
                (ProgressEvent.loaded / ProgressEvent.total) * 100,
            });
          },
        }
      )
      .then((data) => {
        this.props.handleUploadFile({
          Name: this.state.fileToUpload.FileName,
          Id: data.data.FileId,
        });
        this.handleDeleteFileToUpload();
      });
  }

  handleDeleteFileToUpload() {
    this.setState({ fileToUpload: null, isLoading: false });
    this.fileinput.value = "";
  }

  render() {
    const uploadBtn =
      this.state.fileToUpload != null ? (
        <button
          className="btn btn-primary"
          onClick={() => this.uploadFile()}
          disabled={this.state.isLoading}
        >
          Upload
        </button>
      ) : (
        <button
          className="btn btn-default"
          onClick={() => this.fileinput.click()}
        >
          Select a File
        </button>
      );

    return (
      <div className="service-request-submit">
        <div className="sr-container">
          <div className="sr-label">
            <div className="form-group">
              <label>Description of your request</label>
              <textarea
                placeholder="E.g. Placeholder text"
                id="desc"
                cols="30"
                rows="10"
                name="description"
              />
            </div>

            <p>Attach supporting document (optional)</p>
            {this.props.uploadFiles && this.props.uploadFiles.length > 0 && (
              <div>
                <div className="uploaded-files">
                  {this.props.uploadFiles.map((file, index) => (
                    <div key={index} className="file-label">
                      <p className="file-name">{file.Name}</p>
                      <div className="progress-control">
                        <img
                          src={closeIcon}
                          alt=""
                          onClick={() =>
                            this.props.handleDeleteUploadedFile(index)
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <p>Add Another Document (optional)</p>
              </div>
            )}
            {this.state.fileToUpload && (
              <FileToUpload
                file={this.state.fileToUpload}
                onClick={this.handleDeleteFileToUpload}
                progress={this.state.uploadProgress}
                isLoading={this.state.isLoading}
              />
            )}

            {uploadBtn}
          </div>

          <div style={{ display: "none" }}>
            <input
              type="file"
              name="file"
              id="file"
              ref={(input) => (this.fileinput = input)}
              onChange={(e) => this.handleSelectFile(e.target.files[0])}
            />
          </div>
          <button className="btn btn-primary float-right mt-3 px-4">
            Submit
          </button>
          <button
            className="btn btn-default float-right mr-2 mt-3 px-4"
            onClick={() => this.props.goBack()}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }
}

export default ServiceRequestsSubmit;
